// extracted by mini-css-extract-plugin
module.exports = {"container":"blocks-link-container","link":"blocks-link-link"};